/* ko-sticky-atc.js */
(function () {
  "use strict";

  document.addEventListener('DOMContentLoaded', function () {
    const stickyBar = document.getElementById('ko-sticky-atc');
    if (!stickyBar) return;

    const sectionId = stickyBar.getAttribute('data-section-id');
    const stickySelect = document.getElementById('ko-sticky-atc-select');
    const stickyBtn = document.getElementById('ko-sticky-atc-btn');

    // Locate main Dawn elements using the exact elements from your file
    const mainProductInfo = document.querySelector('product-info');
    if (!mainProductInfo) return;

    const mainBuyButtonBlock = mainProductInfo.querySelector('.product-form__buttons');
    const mainSubmitButton = mainProductInfo.querySelector('.product-form__submit');

    // 1. Scroll-Triggered Reveal via IntersectionObserver (Apple style)
    if (mainBuyButtonBlock) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Show sticky bar only when main purchase buttons are fully scrolled out of view
          if (!entry.isIntersecting) {
            stickyBar.classList.add('ko-sticky-atc--active');
            
            // Add padding-bottom to body so the bottom content doesn't get cut off on mobile
            document.body.style.paddingBottom = stickyBar.offsetHeight + 'px';
          } else {
            stickyBar.classList.remove('ko-sticky-atc--active');
            document.body.style.paddingBottom = '0px';
          }
        });
      }, { threshold: 0.1 });

      observer.observe(mainBuyButtonBlock);
    }

    // 2. Synchronize variant selection FROM main variant-picker TO sticky select
    mainProductInfo.addEventListener('change', function () {
      const mainSelect = mainProductInfo.querySelector('form[id^="product-form-"] input[name="id"]');
      if (mainSelect && stickySelect) {
        stickySelect.value = mainSelect.value;
      }

      // Sync button states
      if (mainSubmitButton && stickyBtn) {
        stickyBtn.textContent = mainSubmitButton.textContent;
        stickyBtn.disabled = mainSubmitButton.hasAttribute('disabled');
      }
    });

    // 3. Synchronize variant selection FROM sticky select TO main variant-picker
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        const selectedVal = stickySelect.value;
        
        // Dawn standard swatches trigger via click events
        // If radios exist, we click the matching input; otherwise we update the select
        const mainVariantSelect = mainProductInfo.querySelector('select.select__select');
        if (mainVariantSelect) {
          mainVariantSelect.value = selectedVal;
          mainVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // Trigger variant data update via custom event triggers in product-info.js
          const variantData = JSON.parse(mainProductInfo.querySelector('script[type="application/json"]').textContent);
          const variant = variantData.find(v => v.id == selectedVal);
          if (variant) {
            window.history.replaceState({}, '', `${window.location.pathname}?variant=${selectedVal}`);
            mainProductInfo.dispatchEvent(new CustomEvent('variant-change', {
              detail: { variant: variant }
            }));
          }
        }
      });
    }

    // 4. Trigger actual main form submit on sticky button click (triggers standard AJAX drawer cart!)
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainSubmitButton) {
          mainSubmitButton.click();
        }
      });
    }
  });
})();